"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(_ref) {
  var sendTypingIndicator = _ref.sendTypingIndicator;
  return sendTypingIndicator;
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfZGVmYXVsdCIsIl9yZWYiLCJzZW5kVHlwaW5nSW5kaWNhdG9yIiwiZXhwb3J0cyJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZWxlY3RvcnMvc2VuZFR5cGluZ0luZGljYXRvci50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFJlZHV4U3RhdGUgfSBmcm9tICcuLi90eXBlcy9pbnRlcm5hbC9SZWR1eFN0YXRlJztcblxuZXhwb3J0IGRlZmF1bHQgKHsgc2VuZFR5cGluZ0luZGljYXRvciB9OiBSZWR1eFN0YXRlKTogYm9vbGVhbiA9PiBzZW5kVHlwaW5nSW5kaWNhdG9yO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7ZUFFZSxTQUFBQSxTQUFBQyxJQUFBO0VBQUEsSUFBR0MsbUJBQW1CLEdBQUFELElBQUEsQ0FBbkJDLG1CQUFtQjtFQUFBLE9BQTRCQSxtQkFBbUI7QUFBQTtBQUFBQyxPQUFBLGNBQUFILFFBQUEifQ==